import { ServiceFetch } from '../service-fetch'

export default class FactStockPackModel extends ServiceFetch {
    getFactStockPackBy = (data) => this.authFetch({
        url: 'fact-stock-pack/getFactStockPackBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}